export default __webpack_public_path__ + "static/media/landscapeToPortrait.31d6cfe0.webp";